import { color } from "metabase/ui/colors";
import type { Tenant } from "metabase-types/api";

const groupColorPalette = [
  color("feedback-negative"),
  color("accent2"),
  color("core-brand"),
  color("accent4"),
  color("accent1"),
];

export const tenantIdToColor = (tenantId: Tenant["id"]) => {
  return groupColorPalette[tenantId % groupColorPalette.length];
};
